var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/index.ts
import Axios from "axios";

// src/paramsSerializer.ts
var paramsSerializer = (params) => {
  const urlSearchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === void 0) return;
    if (!Array.isArray(value)) {
      urlSearchParams.append(key, `${value}`);
      return;
    }
    value.forEach((_) => {
      if (_ === void 0) return;
      urlSearchParams.append(key, _);
    });
  });
  return urlSearchParams.toString();
};

// src/dateSerializer.ts
var isoDateFormat = () => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/;
var shortDateFormat = () => /^\d{4}-\d{2}-\d{2}$/;
function isIsoDateString(value) {
  return value && typeof value === "string" && isoDateFormat().test(value);
}
function isShortDateString(value) {
  return value && typeof value === "string" && shortDateFormat().test(value);
}
function deserializeDates(body) {
  if (body === null || body === void 0 || typeof body !== "object") {
    return body;
  }
  for (const key of Object.keys(body)) {
    const value = body[key];
    if (isShortDateString(value)) {
      body[key] = /* @__PURE__ */ new Date(`${value}T00:00:00.000Z`);
    } else if (isIsoDateString(value)) {
      body[key] = new Date(value);
    } else if (typeof value === "object") {
      deserializeDates(value);
    }
  }
  return body;
}
function serializeDates(body) {
  if (body === null || body === void 0 || typeof body !== "object") {
    return body;
  }
  for (const key of Object.keys(body)) {
    const value = body[key];
    if (value instanceof Date) {
      body[key] = value.toISOString().replace("T00:00:00.000Z", "");
    } else if (typeof value === "object") {
      serializeDates(value);
    }
  }
  return body;
}

// src/index.ts
var AXIOS_INSTANCE = Axios.create({
  paramsSerializer
});
AXIOS_INSTANCE.interceptors.request.use((config) => {
  serializeDates(config.params);
  serializeDates(config.data);
  return config;
});
AXIOS_INSTANCE.interceptors.response.use((value) => {
  deserializeDates(value.data);
  return value;
});
var customAxios = (config, options) => {
  const source = Axios.CancelToken.source();
  const promise = AXIOS_INSTANCE(__spreadProps(__spreadValues(__spreadValues({}, config), options), {
    cancelToken: source.token
  })).then((r) => r);
  promise.cancel = () => {
    source.cancel("Query was cancelled");
  };
  return promise;
};
var index_default = AXIOS_INSTANCE;
export {
  AXIOS_INSTANCE,
  customAxios,
  index_default as default,
  deserializeDates,
  serializeDates
};
//# sourceMappingURL=index.mjs.map